// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__QUYyt","footer":"ReportModalFilter_footer__24uzB"};